import React from 'react'
import PropTypes from 'prop-types'
import Style from './style'
import moment from 'moment'
import { range, getMonthNameFull, getWeekDayName } from '../../helpers'
import { COLOR } from '../../themes'
import icExpandMore from '../../themes/images/ic_expand-more.svg'

const defaultList = []

class SmallCalendar extends React.Component {
  constructor(props) {
    super(props)
    props = Object.assign({}, props)
    const allDayInWeek = range(4, 11, 1)
    this.dayInWeek = allDayInWeek.map((day) => {
      return getWeekDayName(new Date(1970, 0, day), props.language)
    })
    const allMonth = range(0, 12, 1)
    this.monthInYear = allMonth.map((month) => {
      return getMonthNameFull(new Date(1970, month, 1), props.language)
    })
    props.selectDate = props.selectDate != null ? props.selectDate : new Date()
    this.weekend = props.weekend ? props.weekend : defaultList
    const startOfMonth = new Date(props.selectDate.getFullYear(), props.selectDate.getMonth(), 1)
    if (props.startSelectable != null) {
      this.startSelectableYear = new Date(props.startSelectable.getFullYear(), 0, 1)
      this.startSelectableMonth = new Date(props.startSelectable.getFullYear(), props.startSelectable.getMonth(), 1)
      this.startSelectableDate = new Date(props.startSelectable.getFullYear(), props.startSelectable.getMonth(), props.startSelectable.getDate())
    }

    if (props.endSelectable != null) {
      this.endSelectableYear = new Date(props.endSelectable.getFullYear(), 0, 1)
      this.endSelectableMonth = new Date(props.endSelectable.getFullYear(), props.endSelectable.getMonth(), 1)
      this.endSelectableDate = new Date(props.endSelectable.getFullYear(), props.endSelectable.getMonth(), props.endSelectable.getDate())
    }
    let selectedDate = new Date(props.year, props.month - 1, props.date, 0, -new Date().getTimezoneOffset())
    this.oneDay = 24 * 60 * 60 * 1000
    this.oneMonth = 30 * this.oneDay
    this.oneYear = 12 * this.oneMonth
    this.state = {
      selectedDate: selectedDate,
      isShowingDate: true,
      isShowingMonth: false,
      isShowingYear: false,
      doReRender: false,
      selectDate: props.selectDate ? props.selectDate.getDate() : null,
      startDay: props.selectDate ? startOfMonth.getDay() : null,
      selectMonth: props.selectDate ? props.selectDate.getMonth() : null,
      selectYear: props.selectDate ? props.selectDate.getFullYear() : null,
      tempMonth: props.tempDate ? props.tempDate.getMonth() : null,
      tempYear: props.tempDate ? props.tempDate.getFullYear() : null,
      language: props.language
    }
  }

  componentDidUpdate () {
    const props = { ...this.props }

    const month = props.isSelectedToday ? - 1 : props.month - 1

    let selectedDate = new Date(props.year, month, props.date, 0, -new Date().getTimezoneOffset())

    if (isNaN(selectedDate.valueOf())) selectedDate = new Date()
    if (selectedDate.valueOf() !== this.state.selectedDate.valueOf()) {
      const startOfMonth = new Date(props.selectDate.getFullYear(), props.selectDate.getMonth(), 1)
      this.setState({
        selectedDate: selectedDate,
        selectDate: props.selectDate ? props.selectDate.getDate() : null,
        startDay: props.selectDate ? startOfMonth.getDay() : null,
        selectMonth: props.selectDate ? props.selectDate.getMonth() : null,
        selectYear: props.selectDate ? props.selectDate.getFullYear() : null,
        tempMonth: props.tempDate ? props.tempDate.getMonth() : null,
        tempYear: props.tempDate ? props.tempDate.getFullYear() : null
      })
    }
    if (props.language !== this.state.language) {
      const allDayInWeek = range(4, 11, 1)
      this.dayInWeek = allDayInWeek.map((day) => {
        return getWeekDayName(new Date(1970, 0, day), props.language)
      })
      const allMonth = range(0, 12, 1)
      this.monthInYear = allMonth.map((month) => {
        return getMonthNameFull(new Date(1970, month, 1), props.language)
      })
      this.setState({
        language: props.language
      })
    }
  }

  detectOnchangeDate () {
    const { pathChange } = this.props
    const { selectDate, selectMonth, selectYear } = this.state
    let object = { selectDate, selectMonth, selectYear }
    pathChange(object)
  }

  handleDateSelect(event, date, selectionType) {
    const { selectYear, selectMonth, doReRender } = this.state
    const {
      setMonthChange,
      setYearChange,
      isSideBar,
      showArrow,
      onClickDate
    } = this.props
  
    function updateDate(newMonth, newYear) {
      const newDate = new Date(newYear, newMonth, date)
      const startOfMonth = new Date(newYear, newMonth, 1)
  
      this.setState({
        isShowingMonth: false,
        isShowingYear: false,
        selectMonth: newDate.getMonth(),
        selectYear: newDate.getFullYear(),
        selectDate: date,
        startDay: startOfMonth.getDay(),
        doReRender: !doReRender,
        tempMonth: newDate.getMonth(),
        tempYear: newDate.getFullYear(),
      }, () => {
        this.detectOnchangeDate()
      })
  
      if (isSideBar) {
        setMonthChange(newDate.getMonth())
        setYearChange(newDate.getFullYear())
      }
    }
  
    if (showArrow) {
      if (selectionType === 'decrement') {
        updateDate.call(this, selectMonth - 1, selectYear)
      } else if (selectionType === 'same') {
        this.setState({
          selectDate: date,
          tempMonth: selectMonth,
          tempYear: selectYear,
        }, () => {
          this.detectOnchangeDate()
        })
  
        if (isSideBar) {
          setMonthChange(selectMonth)
          setYearChange(selectYear)
        }
      } else if (selectionType === 'increment') {
        updateDate.call(this, selectMonth + 1, selectYear)
      }
    } else {
      onClickDate(event, new Date(selectYear, selectMonth, date))
  
      if (isSideBar) {
        setMonthChange(selectMonth)
        setYearChange(selectYear)
      }
    }
  }

  getTotalDayInMonth (month = (new Date()).getMonth(), year = (new Date()).getFullYear()) {
    return 32 - (new Date(year, month, 32)).getDate()
  }

  increaseMonth = async () => {
    const { setMonthChange, setYearChange, handleGetHoliday, setSelectedToday } = this.props

    if (setSelectedToday) {
      await setSelectedToday(false)
    }

    let newDate = new Date(this.state.selectYear, this.state.selectMonth + 1, 1)
    const selectMonth = newDate.getMonth()
    const selectYear = newDate.getFullYear()
    const lastDay = new Date(selectYear, selectMonth + 1, 0).getDate()
    const clampedDate = Math.min(this.state.selectDate || 1, lastDay)

    this.setState({
      isShowingMonth: false,
      isShowingYear: false,
      selectMonth,
      selectYear,
      selectDate: clampedDate,
      startDay: newDate.getDay(),
      doReRender: !this.state.doReRender
    }, () => {
      if (this.props.pathChange) this.detectOnchangeDate()
    })

    localStorage.setItem('smallCalendarMonth', Number(selectMonth))
    setMonthChange(selectMonth)
    setYearChange(selectYear)

    handleGetHoliday(selectMonth, selectYear)
  }

  decreaseMonth = async () => {
    const { setMonthChange, setYearChange, handleGetHoliday, setSelectedToday } = this.props

    if (setSelectedToday) {
      await setSelectedToday(false)
    }

    let newDate = new Date(this.state.selectYear, this.state.selectMonth - 1, 1)
    const selectMonth = newDate.getMonth()
    const selectYear = newDate.getFullYear()
    const lastDay = new Date(selectYear, selectMonth + 1, 0).getDate()
    const clampedDate = Math.min(this.state.selectDate || 1, lastDay)

    this.setState({
      isShowingMonth: false,
      isShowingYear: false,
      selectMonth,
      selectYear,
      selectDate: clampedDate,
      startDay: newDate.getDay(),
      doReRender: !this.state.doReRender
    }, () => {
      if (this.props.pathChange) this.detectOnchangeDate()
    })

    localStorage.setItem('smallCalendarMonth', Number(selectMonth))
    setMonthChange(selectMonth)
    setYearChange(selectYear)

    handleGetHoliday(selectMonth, selectYear)
  }

  getMonth (disabledList = defaultList, today = new Date()) {
    const selectYear = this.state.selectYear
    const selectMonth = this.state.selectMonth
    const todayMonth = today.getMonth()
    return this.monthInYear.map((month, index) => {
      let className = 'currentCar'
      let disabled = null
      const monthObject = new Date(selectYear, index, 1)
      if (this.startSelectableMonth != null && monthObject < this.startSelectableMonth) {
        disabled = true
      } else if (this.endSelectableMonth != null && monthObject > this.endSelectableMonth) {
        disabled = true
      } else if (disabledList.includes(month)) disabled = true
      if (index === todayMonth) className = className.concat(' today')
      if (index === selectMonth) className = className.concat(' selectDate')
      return (
        <button
          key={'month ' + month}
          className={className}
          disabled={disabled}
          onClick={(event) => { this.handleMonthSelect(event, index) }}
        >
          <h3>{month}</h3>
        </button>
      )
    })
  }

  getYear (disabledList = defaultList, startYear = null, endYear = null, today = new Date()) {
    const result = []
    const selectYear = this.state.selectYear
    const todayYear = today.getFullYear()
    if (startYear == null) startYear = (selectYear != null ? selectYear : todayYear) - 10
    if (endYear == null) endYear = (selectYear != null ? selectYear : todayYear) + 10

    for (let year = startYear; year <= endYear; year++) {
      let disabled = null
      let className = 'currentCar'
      const yearObject = new Date(year, 0, 1)
      if (this.startSelectableYear != null && yearObject < this.startSelectableYear) {
        disabled = true
      } else if (this.endSelectableYear != null && yearObject > this.endSelectableYear) {
        disabled = true
      } else if (disabledList.includes(year)) disabled = true
      if (year === todayYear) className = className.concat(' today')
      if (year === selectYear) className = className.concat(' selectDate')
      result.push(
        <button
          key={year}
          className={className}
          disabled={disabled}
          onClick={(event) => { this.handleYearSelect(event, year) }}
        >
          <h3>{year}</h3>
        </button>
      )
    }
    return result
  }

  getCalendar (startDayInWeek = 0, disabledList = defaultList, today = new Date()) {
    const { isSideBar, holidayReducer } = this.props

    let listHoliday = []

    if (isSideBar) {
      listHoliday = holidayReducer.sideBarHolidays
    } else {
      listHoliday = holidayReducer.listHoliday
    }

    const { dateMark } = this.props
    const { colorTheme } = this.props.settingReducer.settingTheme
    const selectDate = this.state.selectDate ? this.state.selectDate : today.getDate()
    const selectMonth = this.state.selectMonth
    const selectYear = this.state.selectYear
    const tempMonth = this.state.tempMonth
    const tempYear = this.state.tempYear
    const weekend = this.weekend

    let style = {}
    let newStyle = {
      background: "transparent",
      border: `1px solid transparent`,
    }
    let markStyle = {
      background: colorTheme + '33',
      border: '1px solid transparent',
      color: '#0A0A0A',
      fontWeight: 500,
      fontFamily: 'NunitoSansRegular, sans-serif',
    }
    let markStyleToday = {
      background: colorTheme + '33',
      border: `1px solid transparent`,
      color: '#0A0A0A',
      fontWeight: 500,
      fontFamily: 'NunitoSansRegular, sans-serif',
    }

    today = new Date(today.getFullYear(), today.getMonth(), today.getDate())
    const isSelectedMonth = (tempMonth === selectMonth) && (tempYear === selectYear)
    const todayMonth = new Date(today.getFullYear(), today.getMonth(), 1)
    const lastDayOfThisMonth = this.getTotalDayInMonth(selectMonth != null ? selectMonth : todayMonth.getMonth(), selectYear != null ? selectYear : todayMonth.getFullYear())
    const lastMonth = new Date(selectYear != null ? selectYear : todayMonth.getFullYear(), selectMonth != null ? selectMonth - 1 : todayMonth.getMonth() - 1, 1)
    const lastDayOfPreMonth = this.getTotalDayInMonth(lastMonth.getMonth(), lastMonth.getFullYear())
    let startDay = this.state.startDay != null ? this.state.startDay : todayMonth.getDay()

    const hasEvent = (style) => ({
      ...(style.color && { color: style.color }),
      ...(style.fontWeight && { fontWeight: style.fontWeight }),
      ...(style.fontFamily && { fontFamily: style.fontFamily }),
    })
    const getDayStyle = (isHoliday, strDay, isToday) => {
      let color = isHoliday || strDay === 'Sun' || strDay === 'Sat'
        ? COLOR.GRAY_20
        : COLOR.BLACK_1
      if (isToday && isSelectedMonth) {
        color = COLOR.WHITE
      }
      return { color }
    }

    if (startDay > startDayInWeek) {
      startDay = startDay - startDayInWeek
    } else {
      startDay = startDay + 7 - startDayInWeek
    }

    const result = []
    // ========== [Previous month] ========== //
    for (let i = lastDayOfPreMonth - (startDay - 1); i <= lastDayOfPreMonth; i++) {
      result.push(
        <button
          key={'prev' + i}
          className='prevCar'
          onClick={(event) => this.props.showArrow && this.handleDateSelect(event, i, 'decrement')}
        >
          <p>{i}</p>
        </button>
      )
    }

    // ========== [First of month to yesterday of date selected] ========== //
    for (let i = 1; i < selectDate; i++) {
      const isToday = moment(new Date(selectYear, selectMonth, i)).format('YYYY-MM-DD')
      const isHoliday = listHoliday.some(item => item.date === isToday)
      let disabled = null
      let className = 'currentCar'

      if (weekend.includes((startDay + i - 1 + startDayInWeek) % 7)) {
        disabled = true
      }

      let classCurrentDay = ''
      if (today.valueOf() === new Date(selectYear, selectMonth, i).valueOf()) {
        if (dateMark.includes(i)) {
          style = markStyleToday
        } else {
          style = newStyle
        }
        classCurrentDay = 'current-day'
      } else if (dateMark) {
        if (dateMark.includes(i)) {
          style = markStyle
        } else {
          style = {}
        }
      }

      const dayInWeek = this.dayInWeek[(i + startDay - 1 + startDayInWeek) % 7]
      className = className.concat(' ' + dayInWeek)

      if (lastDayOfThisMonth >= i) {
        result.push(
          <button
            key={'curr' + i}
            disabled={disabled}
            style={style}
            className={className + ' ' + classCurrentDay}
            onClick={(event) => this.handleDateSelect(event, i, 'same')}
          >
            <p style={{ ...getDayStyle(isHoliday, dayInWeek), ...hasEvent(style) }}>{i}</p>
          </button>
        )
      }
    }

    let disabled = null
    let className = 'currentCar'

    // ========== [Date selected] ========== //
    //#region 
    if (weekend.includes((startDay + selectDate - 1 + startDayInWeek) % 7)) {
      disabled = true
    }

    if (isSelectedMonth) {
      className = className.concat(' selectDate')
    }

    const dateSeleted = new Date(selectYear, selectMonth, selectDate)
    const newDateSelected = moment(dateSeleted).format('YYYY-MM-DD')
    const isHoliday = listHoliday.some(item => item.date === newDateSelected)
    const isDate = today.valueOf() === dateSeleted.valueOf()

    let classCurrentDay = ''
    if (isSelectedMonth) {
      if (isDate) {
        style = newStyle
        classCurrentDay = 'current-day'
      } else {
        style = {}
      }
    } else {
      if (isDate) {
        if (dateMark.includes(dateSeleted.getDate())) {
          style = markStyleToday
        } else {
          style = newStyle
        }
        classCurrentDay = 'current-day'
      } else {
        if (dateMark.includes(dateSeleted.getDate())) {
          style = markStyle
        } else {
          style = {}
        }
      }
    }

    const dayInWeek = this.dayInWeek[(selectDate + startDay - 1 + startDayInWeek) % 7]
    className = className.concat(' ' + dayInWeek)
    result.push(
      <button
        key={'curr' + selectDate}
        disabled={disabled}
        style={style}
        className={className + ' ' + classCurrentDay}
        onClick={(event) => this.handleDateSelect(event, selectDate, 'same')}
      >
        <p
          style={{
            ...getDayStyle(
              isHoliday,
              dayInWeek,
              newDateSelected,
              dateMark
            ),
            ...hasEvent(style),
          }}
        >
          {selectDate}
        </p>
      </button>
    )
    //#endregion

    // ========== [Tomorrow of date selected to end of month] ========== //
    for (let i = selectDate + 1; i <= lastDayOfThisMonth; i++) {
      const dateInLoop = new Date(selectYear, selectMonth, i)
      const newDateInLoop = moment(dateInLoop).format('YYYY-MM-DD')
      const isHoliday = listHoliday.some(item => item.date === newDateInLoop)
      const isDateInLoop = today.valueOf() === dateInLoop.valueOf()
      let disabled = null
      let className = 'currentCar'

      if (weekend.includes((startDay + i - 1 + startDayInWeek) % 7)) {
        disabled = true
      }

      let classCurrentDay = ''
      if (isDateInLoop) { // IF Today
        if (dateMark.includes(i)) { // IF Today has event
          style = markStyleToday
        } else { // IF Today default
          style = newStyle
        }
        classCurrentDay = 'current-day'
      } else { // Not Today
        if (dateMark.includes(i)) { // Not today has event
          style = markStyle
        } else { // Not today default
          style = {}
        }
      }

      const dayInWeek = this.dayInWeek[(i + startDay - 1 + startDayInWeek) % 7]
      className = className.concat(' ' + dayInWeek)

      result.push(
        <button
          key={'curr' + i}
          disabled={disabled}
          style={style}
          className={className + ' ' + classCurrentDay}
          onClick={(event) => this.handleDateSelect(event, i, 'same')}
        >
          <p style={{ ...getDayStyle(isHoliday, dayInWeek), ...hasEvent(style) }}>{i}</p>
        </button>
      )
    }

    style = {}

    // ========== [Next month] ========== //
    for (let i = 1; i <= 42 - (lastDayOfThisMonth + startDay); i++) {
      result.push(
        <button
          key={'next' + i}
          className='nextCar'
          onClick={(event) => this.props.showArrow && this.handleDateSelect(event, i, 'increment')}
        >
          <p>{i}</p>
        </button>
      )
    }

    return result
  }

  getCalendarHeader (startDayInWeek = 0) {
    if (startDayInWeek == null) startDayInWeek = 0

    const dayInWeek = this.dayInWeek.slice(startDayInWeek).concat(this.dayInWeek.slice(0, startDayInWeek))
    return dayInWeek.map((day) => <p key={day} className='calendarHeader'>{!this.props.showArrow ? day.slice(0, 1) : day.slice(0, 2)}</p>)
  }

  toggleMonthView () {
    this.setState({
      isShowingMonth: !this.state.isShowingMonth,
      isShowingYear: false
    })
  }

  toggleYearView () {
    this.setState({
      isShowingYear: !this.state.isShowingYear,
      isShowingMonth: false
    })
  }

  render () {
    const { isNav, settingReducer } = this.props
    const props = Object.assign({}, this.props)
    const month = this.state.selectMonth != null ? this.state.selectMonth : new Date().getMonth()
    const year = this.state.selectYear != null ? this.state.selectYear : new Date().getFullYear()

    const { colorTheme } = settingReducer.settingTheme

    return (
      <Style
        isNav={isNav}
        colorTheme={colorTheme}
      >
        <section className='SmallCalendar jump-in'>
          <section className='MonthnYear'>
            <div className={this.props.showArrow ? 'selectDate' : 'selectDateThin'}>
              <span className='small-year-name'>
                {this.monthInYear[month]} {this.props.showArrow ? year : ''}
              </span>
            </div>
            {this.props.showArrow
              ? (
                <div className='arrow'>
                  <button className='left pointer' onClick={this.decreaseMonth} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: 4 }}>
                    <img src={icExpandMore} alt="previous" width="20" height="20" style={{ transform: 'rotate(90deg)' }} />
                  </button>
                  <button className='pointer' onClick={this.increaseMonth} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img src={icExpandMore} alt="next" width="20" height="20" style={{ transform: 'rotate(-90deg)' }} />
                  </button>
                </div>
              )
              : null
            }
          </section>
          <section className='calendarField'>
            <section
              className={
                'calendarDay ' + ((this.state.isShowingMonth || this.state.isShowingYear) ? 'fade-out' : 'fade-in')
              }
            >
              {this.getCalendarHeader(props.startDay || 0)}
              {this.getCalendar(
                props.startDay ? props.startDay : 0,
                (props.disabledDate &&
                  props.disabledDate[year] &&
                  props.disabledDate[year][month]) ? props.disabledDate[year][month] : defaultList)}
            </section>
            {this.state.isShowingMonth
              ? <section className='calendarMonth slide-in' isshowing={Boolean(this.state.isShowingMonth).toString()}>
                {this.getMonth((props.disabledMonth && props.disabledMonth[year]) ? props.disabledMonth[year] : defaultList)}
              </section>
              : null}
            {this.state.isShowingYear
              ? <section className='calendarYear slide-in' isshowing={Boolean(this.state.isShowingYear).toString()}>
                {this.getYear(props.disabledYear ? props.disabledYear : defaultList, props.startYear, props.endYear)}
              </section>
              : null}
          </section>
        </section>
      </Style>
    )
  }
}

SmallCalendar.propTypes = {
  selectDate: PropTypes.instanceOf(Date),
  startSelectable: PropTypes.instanceOf(Date),
  endSelectable: PropTypes.instanceOf(Date),
  startDay: PropTypes.number,
  startYear: PropTypes.number,
  endYear: PropTypes.number,
  disabledDate: PropTypes.array,
  disabledMonth: PropTypes.shape(),
  disabledYear: PropTypes.shape(),
  isShowing: PropTypes.bool,
  handleGetHoliday: PropTypes.func,
}

export default SmallCalendar
